module.exports = __webpack_public_path__ + "img/ch.5e687674.svg";